<script setup lang="ts">
const props = defineProps<{ basic?: boolean, navigation?: NavigationItem[] }>()
const { data: navigation } = await useAsyncData(
  'navigation-footer',
  async ({ $pb }) => {
    if (props.navigation) return props.navigation
    return await $pb.collection<NavigationItem[]>('navigations').getFullList({ sort: 'order', expand: 'page', fields: '*, expand.page.slug', filter: 'navigationType = "footer"', requestKey: 'footer' })
  },
  {
    transform: data => generateNavigation(data),
  },
)
</script>

<template>
  <div
    id="footercontainer"
    class="relative w-full"
  >
    <LazyVisibleRocketTakeoff
      v-if="!basic"
      hydrate-on-visible
    />

    <div
      id="footerelement"
      class="w-full space-y-10 lg:space-y-0 text-slate-300 gap-6 px-6 py-12 lg:px-12 xl:px-24 lg:py-16 bg-white rounded-t-4xl flex flex-wrap justify-between items-center relative z-20 min-h-[50vh]"
    >
      <div class="w-full lg:flex-1 gap-1 lg:gap-3 flex-col flex">
        <NuxtLink
          v-for="item in navigation"
          :key="item.id"
          class="text-blue hover:text-darkblue font-semibold"
          :to="item.expand?.page?.slug"
        >
          {{ item.label }}
        </NuxtLink>
      </div>

      <div class="w-1/3 flex gap-3 max-w-32 2xl:max-w-64 mx-auto">
        <NuxtImg
          src="/GBF-Keeping-Business-Real-round.png"
          format="webp"
          quality="70"
          width="256"
          height="252"
          sizes="128px 2xl:256px"
          loading="lazy"
          class="w-full h-auto"
          alt="Grampian Business Finder"
        />
      </div>
      <div class="w-full justify-center flex flex-wrap text-slate-700 gap-2">
        <NuxtLink
          to="https://www.facebook.com/groups/GrampianBusinessFinder/"
          target="_blank"
          class="inline-flex items-center gap-2 group"
        >
          <div class="p-1 bg-primary text-white rounded-full flex items-center justify-center group-hover:bg-darkblue">
            <Icon
              name="ri:facebook-box-line"
            />
          </div>Facebook Group</NuxtLink>
        <NuxtLink
          to="https://www.youtube.com/channel/UCDRrc0kZ9auuJjn46GqjB9A"
          class="inline-flex items-center gap-2 group"
          target="_blank"
        >
          <div class="p-1 bg-primary text-white rounded-full flex items-center justify-center group-hover:bg-darkblue">
            <Icon
              name="ri:youtube-line"
            /></div>YouTube</NuxtLink>
        <NuxtLink
          to="https://www.facebook.com/GrampianBusinessFinderGOLD/"
          target="_blank"
          class="inline-flex items-center gap-2 group"
        >
          <div class="p-1 bg-primary text-white rounded-full flex items-center justify-center group-hover:bg-darkblue">
            <Icon
              name="ri:facebook-circle-line"
            /></div>
          Facebook Page</NuxtLink>
      </div>
      <div class="w-full text-slate-500 text-center">
        © 2025 Grampian Business Finder. All Rights Reserved. A <NuxtLink to="https://thislittlepiggy.marketing/" target="_blank">This Little Piggy Marketing</NuxtLink> product.
      </div>
    </div>
  </div>
</template>
